import KeyboardArrowDownOutlined from "@mui/icons-material/KeyboardArrowDownOutlined"
import { Stack } from "@mui/material"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import MenuItem from "@mui/material/MenuItem"
import Popover from "@mui/material/Popover"
import React, { useState } from "react"

import BritishFlag from "@assets/svg_icons/flags/en"
import TurkishFlag from "@assets/svg_icons/flags/tr"
import useTranslate from "@hooks/use_translate"

import styles from "./styles"

export default function LanguageSelector() {
  const { currentLanguage, changeLanguage } = useTranslate()
  const selectedLangIcon =
    currentLanguage === "tr" ? <TurkishFlag /> : <BritishFlag />

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  function handleClickOption(newKey: "en" | "tr") {
    return () => {
      changeLanguage(newKey)
      handleClose()
    }
  }

  return (
    <>
      <Button
        color="secondary"
        onClick={handleClick}
        sx={styles.buttonContainer}
      >
        {selectedLangIcon}
        <KeyboardArrowDownOutlined color="disabled" fontSize="small" />
      </Button>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Card>
          <MenuItem value={"en"} onClick={handleClickOption("en")}>
            <Stack direction={"row"} gap={1}>
              <BritishFlag /> English
            </Stack>
          </MenuItem>
          <MenuItem value={"tr"} onClick={handleClickOption("tr")}>
            <Stack direction={"row"} gap={1}>
              <TurkishFlag /> Türkçe
            </Stack>
          </MenuItem>
        </Card>
      </Popover>
    </>
  )
}
